export const moderateDeficitThreshold = 0.7
